module.exports = __webpack_public_path__ + "img/discover_off.ae1548df.png";